import * as React from "react";
import * as Prism from "prismjs";
import * as ReactRedux from "react-redux";

import { selectors, AppIdInfo } from "../reducers/current_user";

import WithHeaders from "./WithHeaders";

interface HttpHeadersProps {
	headers: HttpHeadersDict;
	shouldDisplayHeading: boolean;
	style?: React.CSSProperties;
	preStyle?: React.CSSProperties;
}

export const HttpHeaders = (props: HttpHeadersProps) => {
	const headersText: string = Object.keys(props.headers)
		.map(headerName => {
			let headerValue: string = props.headers[headerName];

			if (headerName === "Authorization" && headerValue === null) {
				headerValue = "Bearer {JWT}";
			}

			if (headerName === "App-Id" && headerValue === null) {
				headerValue = "{APP-ID}";
			}

			return `${headerName}: ${headerValue}`;
		})
		.join("\n");

	require("prismjs/components/prism-http");
	const grammar = Prism.languages.http;
	const markup = Prism.highlight(headersText, grammar);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				...(props.style || {}),
			}}
		>
			{/* heading */}
			{!props.shouldDisplayHeading ? null : (
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						backgroundColor: "#607D8B",
						paddingTop: "1em",
						paddingBottom: "1em",
						paddingRight: "1em",
						justifyContent: "space-between",
					}}
				>
					<h4
						style={{
							color: "#F0F2F7",
							marginBottom: 0,
							alignSelf: "center",
						}}
					>
						HTTP Headers
					</h4>
				</div>
			)}

			{/* headers */}
			<pre
				className="language-http"
				style={{
					flex: 1,
					marginTop: 0,
					marginBottom: 0,
					wordWrap: "break-word",
					...(props.preStyle || {}),
				}}
			>
				<code style={{ whiteSpace: "pre-wrap" }}>
					<div dangerouslySetInnerHTML={{ __html: markup }} />
				</code>
			</pre>
		</div>
	);
};

interface HttpHeadersInMarkdownProps {
	apiverb: string;
	children?: any;
	apps: AppIdInfo[];
	apiauthtype: string;
}

/**
 * wrapper component for display via Remark/Rehype
 */
const HttpHeadersInMarkdownComponent = (props: HttpHeadersInMarkdownProps) => {
	return (
		<WithHeaders
			httpVerb={props.apiverb}
			appId={props.apps.length > 0 ? props.apps[0].value : undefined}
			authType={props.apiauthtype}
		>
			{headers => {
				/*
                    note: http headers can be overridden by specifying them as key-
                    value pairs in the markdown body... ie.

                    <http-headers>
                    Content-Type: multipart/form-data
                    X-New-Header: hello world
                    </http-headers>
                */

				const overrides = (props.children.length === 1 ? props.children[0] : "")
					.split("\n")
					.reduce((tempOverrides, line) => {
						// empty lines should be skipped
						if (line.length === 0) {
							return tempOverrides;
						}

						const lineComponents = line.split(":");

						if (lineComponents.length < 2) {
							throw new Error(
								"HttpHeaders component: overridden http headers were in wrong format"
							);
						}

						const headerName = lineComponents[0].trim();
						const headerValue = lineComponents[1].trim();

						tempOverrides[headerName] = headerValue;
						return tempOverrides;
					}, {});

				return (
					<HttpHeaders
						{...props}
						headers={{ ...headers, ...overrides }}
						shouldDisplayHeading={true}
						style={{
							marginBottom: "1.61em",
						}}
					/>
				);
			}}
		</WithHeaders>
	);
};

const mapStateToProps = state => ({
	apps: selectors.selectApps(state),
});

export const HttpHeadersInMarkdown = ReactRedux.connect(mapStateToProps)(
	HttpHeadersInMarkdownComponent
);

export default HttpHeaders;



// WEBPACK FOOTER //
// ./src/components/HttpHeaders.tsx